export const ThinkingIndicator = () => (
  <div className="flex items-center gap-1 text-muted-foreground animate-fade-in">
    <div className="w-2 h-2 bg-muted-foreground/60 rounded-full animate-bounce [animation-delay:0ms]" />
    <div className="w-2 h-2 bg-muted-foreground/60 rounded-full animate-bounce [animation-delay:150ms]" />
    <div className="w-2 h-2 bg-muted-foreground/60 rounded-full animate-bounce [animation-delay:300ms]" />
    <span className="ml-2 italic text-sm">Thinking…</span>
  </div>
);
